import { render, staticRenderFns } from "./ImportOrganizationDialog.vue?vue&type=template&id=284e16eb&scoped=true&"
import script from "./ImportOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./ImportOrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImportOrganizationDialog.vue?vue&type=style&index=0&id=284e16eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e16eb",
  null
  
)

export default component.exports